function setUserViewedAppTip(appTipId)
{
  console.log("setting user viewed app tip...");
  const teamId = document.getElementById("team-id")?.value;
  if (!teamId) {
    console.log("no active team, skipping app tip view tracking");
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.open("POST", `/team/${teamId}/api/mutate`, true);
  xhr.timeout = 2000;
  xhr.responseType = "json";
  xhr.setRequestHeader("content-Type", "application/json");
  xhr.setRequestHeader("X-CSRF-Token", document.querySelector("input[name=__anti-forgery-token]")?.value);
  const data = {
    "key": "user/viewed-app-tip",
    "app-tip-id": appTipId
  };

  xhr.onload = () => {
    // print JSON response
    if (xhr.status !==  200) {
      let response = null;
      try
      {
        response = JSON.parse(xhr.responseText);
      }
      catch(e)
      {
        response = "Unknown Error";
      }
      console.log("setting app tip as viewed failed with status", xhr.status, ": ", response);
    }
  };

  xhr.send(JSON.stringify(data));
}

export function initAppTip(appTipId) {
  document.addEventListener('click', (evt) => {
    const el = evt.target;
    if (!el) return;
    const dismissTip = el.dataset['appTipDismiss'];
    if (!dismissTip || dismissTip !== appTipId)
      return;

    setUserViewedAppTip(appTipId);
  });
}
